import axios from 'axios';
import Environment from '../../../environments/environment';
import {Interceptors} from './Interceptors';

export const devApi = axios.create({
  baseURL: Environment.getDevUrl(),
});

devApi.interceptors.response.use(
  (response) => Interceptors.responseInterceptorSuccess(response),
  (err) => Interceptors.responseInterceptorError(err));

devApi.interceptors.request.use((request) =>
  Interceptors.requestInterceptor(request)
)
